import React from 'react'
import Layout from '../../Layout'
import AddResturantCategoryContainer from '../../../../Components/Category/AddResturantCategoryContainer/AddResturantCategoryContainer'

const AddResturantCategory = () => {
  return (
    <Layout><AddResturantCategoryContainer/></Layout>
  )
}

export default AddResturantCategory